import { useCallback, useMemo } from 'react';
import { StyledEmailLink } from './styles';

const encodeToEntities = (str) => {
  return str
    .split('')
    .map((char) => `&#${char.charCodeAt(0)};`)
    .join('');
};

const obfuscateEmail = (email) => {
  const reversed = email.split('').reverse().join('');
  return btoa(reversed);
};

const deobfuscateEmail = (obfuscated) => {
  try {
    const decoded = atob(obfuscated);
    return decoded.split('').reverse().join('');
  } catch {
    return '';
  }
};

const ProtectedEmail = ({ email, sx = {}, children, ...rest }) => {
  const obfuscatedData = useMemo(() => obfuscateEmail(email), [email]);
  const displayText = useMemo(() => encodeToEntities(children || email), [children, email]);

  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      const realEmail = deobfuscateEmail(obfuscatedData);
      if (realEmail) {
        window.location.href = `mailto:${realEmail}`;
      }
    },
    [obfuscatedData]
  );

  return (
    <StyledEmailLink
      component="span"
      role="link"
      tabIndex={0}
      data-e={obfuscatedData}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick(e);
        }
      }}
      sx={sx}
      dangerouslySetInnerHTML={{ __html: displayText }}
      {...rest}
    />
  );
};

export default ProtectedEmail;
